<template>
  <span>
    <el-select
      style="width:100%"
      v-if="'view' != mode"
      v-model="tags"
      multiple
      remote
      :remote-method="remoteLoad" 
      filterable
      allow-create
      default-first-option
      placeholder="点我选择, 或输入后回车"
      @change="onChange">
      <el-option v-for="item in options" :key="item" :label="item" :value="item" />
    </el-select>

    <span v-if="'view'==mode">
      <el-popover width="450" placement="right" :open-delay="200" trigger="hover">
        <!-- 浮窗部分 -->
        <span class="tag_1 tag_3" v-for="tag in tags" :key="tag">{{tag}}</span>

        <!-- 直接展示部分 -->
        <span slot="reference">
          <span class="tag_1 tag_2" v-for="tag in tags" :key="tag">{{tag}}</span>
        </span>
      </el-popover>
    </span>
  </span>
</template>

<script>
import CacheUtil from '@/assets/utils/CacheUtil'

export default {
  name: "TicketTag",

  props: ['ticketNo', 'pmode'],

  data() {
    return {
      tags : [],
      mode : '',
      options : []
    };
  },

  watch : {
    ticketNo() {
      this._onLoad();
    }
  },

  mounted() {
    var _this = this;

    // 详情模式
    if ( "/ticket-vue/ticket/detail" == _this.$route.path || _this.pmode == 'detail') {
      _this.mode = 'detail';
      _this.doLoad_0([this]);
      return;
    }

    // 列表模式
    if ( "/ticket-vue/ticket/view" == _this.$route.path
      || "/ticket-vue/ticket/Project" == _this.$route.path 
      || "/ticket-vue/merchant-ticket" == _this.$route.path ) {
      _this.mode = 'view';
    }

    // 详情模式
    if ( "/ticket-vue/ticket/detail" == _this.$route.path ) {
      var _ticketTagList = JSON.parse(localStorage.getItem(CacheUtil.TicketTagListCache) || "[]");
      _this.options = [..._ticketTagList];
    }

    _this._onLoad();
  },

  methods: {
    clearValue() {
      this.tags = [];
    },

    remoteLoad(_query) {
      if ( !_query || "" == _query) {
        return;
      }

      var _this = this;
      sdk.TicketTagApi().search({
        key : _query
      }).then((res)=>{
        _this.options = [...res];
      });
    },

    _onLoad() {
      // console.log('#99 TicketTag _onLoad', this);

      var _this = this;

      // 初始化
      _this.tags = [];

      if ( !window._TicketTagList ) {
          window._TicketTagList = [];
      }

      window._TicketTagList.push(this);

      clearTimeout(window._TicketTagTimeoutId);
      window._TicketTagTimeoutId = setTimeout(this._doLoad, 100);
    },

    _doLoad() {
        if ( !window._TicketTagList ) {
            console.log("#130 window._TicketTagList=", window._TicketTagList);

            clearTimeout(window._TicketTagTimeoutId);
            window._TicketTagTimeoutId = setTimeout(this._doLoad, 1500); // 太快了？
            return;
        }

        this.doLoad_0(window._TicketTagList);
    },

    doLoad_0(_ticketTagList) {
      var _nos = _ticketTagList.map(e => e.ticketNo).filter(e => !!e);
      if ( !_nos || _nos.length < 1 ) {
        return;
      }

      sdk.TicketTagApi().listByTicketNos({
        nos : _nos
      }).then(res=> {
        for ( var i=0; i<res.length; i++ ) {
            _ticketTagList[i].tags = res[i];
        }

        // 清理
        window._TicketTagTimeoutId = null;
        window._TicketTagList = null;
      });
    },

    onChange(vals) {
      if ( !this.ticketNo ) {
        this.$emit('change', vals);
        this.$emit('input', vals);
        return;
      }

      var _this = this;

      var _ticketTagList = JSON.parse(localStorage.getItem(CacheUtil.TicketTagList) || "[]");
      var _tags = _this.tagDistinct(vals.concat(_ticketTagList));

      localStorage.setItem(CacheUtil.TicketTagListCache, JSON.stringify(_tags));

      sdk.TicketTagApi().updateTicketTag({
        no :  _this.ticketNo,
        tags : vals
      }).then(()=>{
        _message('修改工单标签成功');

        this.$emit('change', vals);
      });
    }
  }
};
</script>

<style scoped>
.tag_3 {
  display : inline-block;
  margin : 4px;
}

.tag_2 {
  text-overflow : ellipsis;
  white-space : nowrap;
  margin : 0 1px;
}

.tag_1 {
  padding : 1px 5px;

  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  background-color: #f4f4f5;
  border-color: #e9e9eb;
  color: #909399;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketTag.vue